<template>
  <div class="fixed top-[20px] left-0 w-full h-[60px] z-[10] text-[14px]">
    <div
      class="mx-auto w-[1180px] h-full p-[16px] flex items-center bg-white bg-opacity-[87] rounded-[36px] backdrop-blur-[6px] backdrop-filter nav-shadow font-medium"
    >
      <div
        class="w-[73px] h-[32px] ml-[18px] mr-[56px] -mt-[14px] flex-y-center"
      >
        <img
          class="w-full h-full cursor-pointer"
          :src="getImageUrl('logo-youyan.webp', 'h_64')"
          alt="logo-youyan"
          fetchpriority="low"
          @click="gotoHome"
        />
      </div>
      <ul class="flex flex-1 items-center">
        <li
          v-for="nav in headerNavList"
          :key="nav.name"
          class="black-text no-underline mr-[40px] leading-[20px] group flex justify-center items-center"
        >
          <a
            v-if="!nav.children"
            :href="getRedirectLink(nav.link)"
            :target="nav.target"
            class="no-underline xmov-link"
            @click.prevent="handleNavClick(nav)"
          >
            <div class="relative">
              {{ nav.name }}
              <div
                class="absolute -bottom-[4px] left-0 w-full h-[2px] bg-primary hidden"
              />
            </div>
          </a>
        </li>
      </ul>
      <div v-if="account?.user_id || tempUser">
        <a
          v-if="userInfo?.logo_url"
          :href="getRedirectLink(`${config.public.apiDomain}/platform`)"
          class="w-[40px] h-[40px] rounded-[20px] inline-block avatar"
          @click.prevent="handleHomeClick"
        >
          <img
            class="w-[40px] h-[40px] rounded-[20px] border-solid border-[1px] border-[#E5E5E8]"
            :src="OSSProcess(logoUrl, 'w_80')"
            alt="Avatar"
            fetchpriority="low"
          />
        </a>
      </div>
      <div v-else class="flex-center">
        <div
          class="w-[80px] h-[36px] rounded-[23px] cursor-pointer flex-center btn-xmov backdrop-blur-[3px] relative"
          data-tip="注册立享免费试用"
        >
          <a
            :href="getRedirectLink(LoginUrl)"
            class="wh-full flex-center no-underline text-white tracking-[1px] login-btn"
            @click.prevent="handleLoginClick"
          >
            登录
          </a>
          <div class="absolute login-tip">注册立享免费试用</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { tempUserAvatar } from '~/constants/landing'
import { TRACK_EVENT, trackEvent } from '~/utils/track'
import { OSSProcess, getRedirectLink } from '~/utils/landing'
const config = useRuntimeConfig()
const tempUser = useTempUser()

interface Nav {
  name: string
  link?: string
  track?: TRACK_EVENT
  children?: Nav[]
  target?: string
}

const handleLoginClick = () => {
  trackEvent(TRACK_EVENT.CLICK_LOGIN)
  window.location.href = getRedirectLink(LoginUrl, true)
}

const handleNavClick = (nav: Nav) => {
  nav.track && trackEvent(nav.track)
  window.location.href = getRedirectLink(nav.link, true)
}

const handleHomeClick = () => {
  trackEvent(TRACK_EVENT.PROFILE_PHOTO)
  location.href = getRedirectLink(`${config.public.apiDomain}/platform`, true)
}

const headerNavList = ref<Nav[]>([
  {
    name: '首页',
    link: '/platform',
    track: TRACK_EVENT.CLICK_HOME,
  },
  {
    name: '作品中心',
    link: '/template',
    track: TRACK_EVENT.CLICK_TEMPLATE,
  },
  {
    name: '应用场景',
    link: '/scenarios',
    track: TRACK_EVENT.CLICK_SCENARIO,
  },
  {
    name: '付费订阅',
    link: '/subscribe',
    track: TRACK_EVENT.CLICK_PAYPAGE,
  },
  {
    name: '教程',
    link: '/tutorial',
    track: TRACK_EVENT.CLICK_TUTORIAL,
  },
  {
    name: '资讯',
    link: '/blog',
    target: '_blank',
  },
])

const LoginUrl = '/login'

const account = useCurrentAccount()

const userInfo = useUserInfo()

const logoUrl = computed(() => {
  return userInfo.value?.logo_url || tempUserAvatar
})

function gotoHome() {
  trackEvent(TRACK_EVENT.CLICK_LOGO)
  window.location.href = getRedirectLink(window.location.origin, true)
}
</script>

<style scoped lang="scss">
.group:hover {
  color: #121926;
  font-weight: 500;
  .hidden {
    display: block;
  }
}

.nav-shadow {
  box-shadow: 0px 4px 16px 0px rgba(6, 5, 25, 0.1);
}

.cur-gradient {
  background: linear-gradient(137deg, #a29efd 0%, #00a0e9 100%, #8cdaff 100%);
}

.avatar {
  position: relative;
  cursor: pointer;
}

.avatar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0);
  /* 初始为透明 */
  transition: background-color 0.3s;
  /* 添加过渡效果 */
  z-index: 1;
  /* 确保蒙层在图片之上 */
}

.avatar:active::before {
  background-color: rgba(0, 0, 0, 0.3);
  /* 鼠标悬停时的灰色蒙层 */
}

.login-btn {
  background-color: var(--purple-6);
  border-radius: 24px;
  &:hover {
    color: #fff;
    opacity: 0.8;
  }
}

.login-tip {
  font-size: 14px;
  padding: 4px 12px;
  font-weight: 500;
  color: #fff;
  border-radius: 4px;
  background: linear-gradient(90deg, #fa48a7 0%, #a263ff 100%);
  left: -20px;
  transform: translateX(-100%);
  width: max-content;

  &::before {
    content: '';
    position: absolute;
    right: -15px;
    width: 0;
    height: 0;
    top: 50%;
    transform: translateY(-50%);
    border-left: 18px solid #a263ff;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
  }
}
.black-text {
  color: rgb(18 25 38 / 0.7);
}
</style>
